import { Box, Stack, Typography } from "@mui/material";

import { PatientSupportingDocumentRecord } from "./types";
import { PatientSupportingDocumentTile } from "./PatientSupportingDocumentTile";

interface PatientSupportingDocumentListProps {
  documents: PatientSupportingDocumentRecord[];
  pageLayout: boolean;
  onView: (document: PatientSupportingDocumentRecord) => void;
  onRemove: (document: PatientSupportingDocumentRecord) => void;
  onReplace?: (document: PatientSupportingDocumentRecord) => void;
}

/** Grid de tiles interno ao card — alinhado ao DocumentsChecklist profissional. */
export function PatientSupportingDocumentList({
  documents,
  pageLayout,
  onView,
  onRemove,
  onReplace,
}: PatientSupportingDocumentListProps) {
  if (!documents.length) {
    return (
      <Typography variant="caption" color="text.secondary">
        Nenhum arquivo enviado ainda.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        maxHeight: pageLayout ? 280 : 300,
        overflowY: "auto",
        overflowX: "hidden",
        borderRadius: 1,
        border: 1,
        borderColor: "grey.200",
        bgcolor: "grey.50",
        p: 0.75,
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 0.875,
          alignContent: "start",
        }}
      >
        {documents.map((document, index) => (
          <PatientSupportingDocumentTile
            key={
              document.documentReferenceId ??
              `${document.fileName}-${document.updatedAt}`
            }
            document={document}
            index={index}
            onView={onView}
            onRemove={onRemove}
            onReplace={onReplace}
          />
        ))}
      </Box>
    </Box>
  );
}
